import React from 'react';
import {
  Button,
  Modal,
  Typography,
  createModal,
} from '@mashvisor/design-system';
import ImageSrc from '../../images/exit-intent-popup.png';
import { useExitIntentPopup } from './useExitIntentPopup';
import styles from './ExitIntentPopup.module.css';

const whyUsingMashvisorPoints: string[] = [
  'Identify which markets provide the highest ROI',
  'Analyze revenue potential for long-term and short-term rental strategies',
  'Manage their properties with vacation rental management tools',
];

const ExitIntentPopup = createModal(() => {
  const modal = useExitIntentPopup();

  return (
    <Modal
      afterClose={modal.remove}
      closable
      width={920}
      open={modal.visible}
      onClose={modal.hide}
      className={styles.modal}
    >
      <div className={styles.container}>
        <div className={styles.leftContent}>
          <Typography
            variant="subHeading"
            color="#1E1E1E"
            fontWeight="semiBold"
            marginBottom={16}
          >
            Find out how your competitors are using Mashvisor to:
          </Typography>
          <ul className={styles.list}>
            {whyUsingMashvisorPoints.map((point, index) => (
              <li key={index}>
                <Typography variant="body1" color="#1E1E1E">
                  {point}
                </Typography>
              </li>
            ))}
          </ul>
          <Button
            margin="auto"
            color="green"
            marginTop={32}
            width={320}
            height={36}
            size="big"
            href="/demo-request"
          >
            Talk to our Product Expert
          </Button>
        </div>
        <div className={styles.rightContent}>
          <img
            src={ImageSrc}
            alt="exit-intent-image"
            width={460}
            height={300}
          />
        </div>
      </div>
    </Modal>
  );
});
export default ExitIntentPopup;
